import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import {
  CUSTOMER_REGISTRATION,
  FORGOT_PASSWORD,
  IFRAME_COMPONENT,
  LOGIN,
  PAYMENT_CANCLED,
  PAYMENT_FAILURE,
  PAYMENT_PROCESSING,
  PAYMENT_SUCCESS,
  RESET_PASSWORD,
  UNAUTHORIZE_BOOKING_AIRPORT,
  UNAUTHORIZE_BOOKING_AIRPORT_DETAILS,
  UNAUTHORIZE_BOOKING_PASSENGER_DETAILS,
  UNAUTHORIZE_BOOKING_SUMMARY,
  VENDOR_REGISTRATION,
  VERIFY_EMAIL,
  VERIFY_OTP,
} from "./component/common/Routes/AppRoutes";
import { StyledBox } from "./Style";
import { Box, CssBaseline } from "@mui/material";
import React, { useEffect, useState } from "react";
import UnauthenticatedRoutes from "./component/common/Routes/UnauthenticatedRoutes";
import AuthenticatedRoutes from "./component/common/Routes/AuthenticatedRoutes";
import CustomerAuthenticatedRoutes from "./component/common/Routes/CustomerAuthenticatedRoutes";
import VendorAuthenticatedRoutes from "./component/common/Routes/VendorAuthenticatedRoutes";
import TopBar from "./component/common/components/TopBar";
import SideBar from "./component/common/components/SideBar";
import "./App.css";
import IframeComponent from "./Screens/UnAuthBooking/IframeComponent";
import UnAuthAirportDetails from "./Screens/UnAuthBooking/UnAuthAirportDetails";
import ForgotPassword from "./redux/auth/components/ForgotPasswordForm";
import VerifyEmail from "./redux/auth/components/VerifyEmail";
import ResetPassword from "./redux/auth/components/ResetPassword";
import CustomerRegistration from "./Screens/Customer/CustomerRegistration";
import VendorRegistration from "./Screens/Vendor/VendorRegistration";
import VerifyOTP from "./Screens/Customer/VerifyOTP";
import PaymentSuccess from "./Screens/Payment/PaymentSuccess";
import PaymentFailure from "./Screens/Payment/PaymentFailure";
import PaymentProcessingPage from "./Screens/Payment/PaymentProcessingPage";
import PaymentCancellation from "./Screens/Payment/PaymentCancle";
import UnAuthBookingSummary from "./Screens/UnAuthBooking/UnAuthBookingSummary";
import UnAuthPassengerDetails from "./Screens/UnAuthBooking/UnAuthPassengerDetails";
import AirportBookingForm1 from "./Screens/UnAuthBooking/AirportBookingForm1";

export const AppContent = ({
  isAuthenticated,
  user,
  isDrawerOpen,
  handleDrawerToggle,
  anchorElUser,
  handleOpenUserMenu,
  handleCloseUserMenu,
  getDashboardRoute,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const noHeaderRoutes = [
    "/new-booking",
    "/new-booking/booking-passenger-details",
    "/new-booking/booking-summary",
    "/new-booking/airport-details",
  ];
  const hideLayout = noHeaderRoutes.includes(location.pathname);
  console.log("location.pathname", location.pathname);
  console.log("hideLayout", hideLayout);
  console.log("isAuthenticated", isAuthenticated);
  console.log("user", user);
  const [redirectPath, setRedirectPath] = useState(null);
  const [hasInitialRedirect, setHasInitialRedirect] = useState(false);

  // Handle authentication changes and navigation
  useEffect(() => {
    if (isAuthenticated && user) {
      // Redirect to dashboard/profile from login routes if authenticated
      const loginRoutes = ["/", "/customer/login", "/vendor/login"];
      if (!hasInitialRedirect && loginRoutes.includes(location.pathname)) {
        const dashboardPath = getDashboardRoute();
        setRedirectPath(dashboardPath);
        setHasInitialRedirect(true);
      } else if (!hasInitialRedirect) {
        setHasInitialRedirect(true);
      }
    } else if (
      !isAuthenticated &&
      !noHeaderRoutes.includes(location.pathname)
    ) {
      // Reset the initial redirect flag when not authenticated
      setHasInitialRedirect(false);

      // Only redirect to login if not on a no-header route (like new-booking)
      const publicRoutes = [
        "/",
        "/customer/login",
        "/vendor/login",
        "/payment-process",
        UNAUTHORIZE_BOOKING_AIRPORT_DETAILS,
        FORGOT_PASSWORD,
        VERIFY_EMAIL,
        RESET_PASSWORD,
        CUSTOMER_REGISTRATION,
        VENDOR_REGISTRATION,
        VERIFY_OTP,
        PAYMENT_SUCCESS,
        PAYMENT_FAILURE,
        PAYMENT_PROCESSING,
        PAYMENT_CANCLED,
        UNAUTHORIZE_BOOKING_AIRPORT,
        UNAUTHORIZE_BOOKING_PASSENGER_DETAILS,
        UNAUTHORIZE_BOOKING_SUMMARY,
        IFRAME_COMPONENT,
      ];

      if (!publicRoutes.includes(location.pathname)) {
        navigate(LOGIN, {
          state: { from: location.pathname },
          replace: true,
        });
      }
    }
  }, [
    isAuthenticated,
    user,
    location.pathname,
    getDashboardRoute,
    navigate,
    hasInitialRedirect,
  ]);

  useEffect(() => {
    if (redirectPath) {
      const timer = setTimeout(() => setRedirectPath(null), 100);
      return () => clearTimeout(timer);
    }
  }, [redirectPath]);

  return (
    <Box className="main-header">
      <CssBaseline />
      {!hideLayout && isAuthenticated && user && (
        <>
          <TopBar
            isDrawerOpen={isDrawerOpen}
            handleDrawerToggle={handleDrawerToggle}
            anchorElUser={anchorElUser}
            handleOpenUserMenu={handleOpenUserMenu}
            handleCloseUserMenu={handleCloseUserMenu}
          />

          <SideBar
            userRole={user?.role || user?.user_type_role_name}
            isDrawerOpen={isDrawerOpen}
            handleDrawerToggle={handleDrawerToggle}
            permissions={user?.permissions}
          />
        </>
      )}

      <StyledBox
        isAuthenticated={isAuthenticated}
        className={
          isAuthenticated && user ? "dashboard-main-content" : "auth-container"
        }
      >
        {redirectPath && <Navigate to={redirectPath} replace />}
        <Routes>
          <Route path="/" element={<UnauthenticatedRoutes />} />
          <Route path="/customer/login" element={<UnauthenticatedRoutes />} />
          <Route path="/vendor/login" element={<UnauthenticatedRoutes />} />
          <Route path={FORGOT_PASSWORD} element={<ForgotPassword />} />
          <Route path={VERIFY_EMAIL} element={<VerifyEmail />} />
          <Route path={RESET_PASSWORD} element={<ResetPassword />} />
          <Route
            path={CUSTOMER_REGISTRATION}
            element={<CustomerRegistration />}
          />
          <Route path={VENDOR_REGISTRATION} element={<VendorRegistration />} />
          <Route path={VERIFY_OTP} element={<VerifyOTP />} />
          <Route path={PAYMENT_SUCCESS} element={<PaymentSuccess />} />
          <Route path={PAYMENT_FAILURE} element={<PaymentFailure />} />
          <Route
            path={PAYMENT_PROCESSING}
            element={<PaymentProcessingPage />}
          />
          <Route path={PAYMENT_CANCLED} element={<PaymentCancellation />} />
          <Route
            path={UNAUTHORIZE_BOOKING_AIRPORT}
            element={<UnAuthAirportDetails />}
          />
          <Route
            path={UNAUTHORIZE_BOOKING_AIRPORT_DETAILS}
            element={<AirportBookingForm1 />}
          />
          <Route
            path={UNAUTHORIZE_BOOKING_PASSENGER_DETAILS}
            element={<UnAuthPassengerDetails />}
          />
          <Route
            path={UNAUTHORIZE_BOOKING_SUMMARY}
            element={<UnAuthBookingSummary />}
          />
          <Route path={IFRAME_COMPONENT} element={<IframeComponent />} />
          {isAuthenticated ? (
            <>
              <Route
                path="/"
                element={<Navigate to={getDashboardRoute()} replace />}
              />
              {(() => {
                const activeRole = (
                  user?.role ||
                  user?.user_type_role_name ||
                  ""
                ).toLowerCase();
                if (activeRole === "customer") {
                  return (
                    <Route
                      path="/*"
                      element={<CustomerAuthenticatedRoutes />}
                    />
                  );
                } else if (activeRole === "vendor") {
                  return (
                    <Route path="/*" element={<VendorAuthenticatedRoutes />} />
                  );
                } else {
                  return <Route path="/*" element={<AuthenticatedRoutes />} />;
                }
              })()}
            </>
          ) : (
            <Route
              path="/*"
              element={
                <Navigate
                  to={LOGIN}
                  state={{ from: location.pathname }}
                  replace
                />
              }
            />
          )}
        </Routes>
      </StyledBox>
    </Box>
  );
};
